import { aqua1000, aqua500, aqua700, aquaA1000, black, blue300, blue500, blue700, blue900, cyan1000, cyan900, green1000, green400, green700, greenA1000, lightBlue400, lightBlue700, lime1000, lime500, lime700, limeA1000, orange1000, orange400, orange600, orangeA1000, purple1000, purple300, purple500, purple700, red1000, red300, red500, redA1000, steelGrey100, steelGrey1000, steelGrey200, steelGrey300, steelGrey50, steelGrey500, steelGrey600, white, yellow1000, yellow500, yellow700, yellowA1000 } from "@m/alchemy-theme";
export const backgroundColorPalette = [
    black,
    steelGrey1000,
    steelGrey600,
    steelGrey500,
    steelGrey300,
    steelGrey200,
    steelGrey100,
    white,
    "#ffffff00",
    purple300,
    blue300,
    lightBlue400,
    aqua500,
    green400,
    lime500,
    yellow500,
    orange400,
    red300,
    purple500,
    blue500,
    lightBlue700,
    aqua700,
    green700,
    lime700,
    yellow700,
    orange600,
    red500,
    purple700,
    blue700,
    cyan900,
    aqua1000,
    green1000,
    lime1000,
    yellow1000,
    orange1000,
    red1000,
    purple1000,
    blue900,
    cyan1000,
    aquaA1000,
    greenA1000,
    limeA1000,
    yellowA1000,
    orangeA1000,
    redA1000
];
// transparent spot replaced with white and new grey replaces white's position
export const textColorPalette = [
    black,
    steelGrey1000,
    steelGrey600,
    steelGrey500,
    steelGrey300,
    steelGrey200,
    steelGrey100,
    steelGrey50,
    white,
    purple300,
    blue300,
    lightBlue400,
    aqua500,
    green400,
    lime500,
    yellow500,
    orange400,
    red300,
    purple500,
    blue500,
    lightBlue700,
    aqua700,
    green700,
    lime700,
    yellow700,
    orange600,
    red500,
    purple700,
    blue700,
    cyan900,
    aqua1000,
    green1000,
    lime1000,
    yellow1000,
    orange1000,
    red1000,
    purple1000,
    blue900,
    cyan1000,
    aquaA1000,
    greenA1000,
    limeA1000,
    yellowA1000,
    orangeA1000,
    redA1000
];
